'use client';
import { SocialIcons as SharedSocialIcons } from '@launchstore/shared-puck';
import type { SocialIconsProps } from '@launchstore/shared-puck';
export const SocialIcons: any = SharedSocialIcons;
export type { SocialIconsProps };
export default SocialIcons;
